import { render } from "./CustomBrandingThemePreview.vue?vue&type=template&id=2a3aa207&scoped=true&ts=true"
import script from "./CustomBrandingThemePreview.vue?vue&type=script&lang=ts"
export * from "./CustomBrandingThemePreview.vue?vue&type=script&lang=ts"

import "./CustomBrandingThemePreview.vue?vue&type=style&index=0&id=2a3aa207&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3aa207"]])

export default __exports__